import designPath from "../../assets/images/separator.svg";

export default function Separator(): JSX.Element {
  return (
    <img src={designPath} alt="separator" className="separator-container" />
  );
}
